export const formatPrice = (price: number) => {
  return `${price}`
}

export const formatJapaneseNumber = (input: number | string) => {
  if (input === null || input === undefined) return ''

  let number: number
  if (typeof input === 'string') {
    number = parseFloat(input.replace(',', '.'))
    if (isNaN(number)) return ''
  } else {
    number = input
  }

  return number.toLocaleString('ja-JP', {
    maximumFractionDigits: 5,
  })
}
